module.exports = __webpack_public_path__ + "img/logo.e7b8d9a0.svg";